import { create } from "zustand";

type onOpenProps = {
  studySetId?: string;
};

type ModalStore = {
  studySetId?: string;
  isOpen: boolean;
  onOpen: ({ studySetId }: onOpenProps) => void;
  onClose: () => void;
};

const useAddToFolderModal = create<ModalStore>((set) => ({
  isOpen: false,
  onOpen: ({ studySetId }) =>
    set({
      isOpen: true,
      studySetId,
    }),
  onClose: () => set({ isOpen: false }),
}));

export default useAddToFolderModal;
